var map = {
	"./aa-Institution Data Submitted for NIRF 2017.pdf": 30364,
	"./ab-Institution Data Submitted for NIRF 2018.pdf": 19254,
	"./ac-Institution Data Submitted for NIRF 2019.pdf": 11576,
	"./ad-Institution Data Submitted for NIRF 2020.pdf": 30633,
	"./ae-Institution Data Submitted for NIRF 2021.pdf": 20703,
	"./af-Institution Data Submitted for NIRF 2022.pdf": 77673,
	"./ag-Institution Data Submitted for NIRF 2023.pdf": 37419,
	"./ah-Institution Data Submitted for NIRF 2024 - Innovation Category.pdf": 57439,
	"./ai-Institution Data Submitted for NIRF 2024 - Engineering Category.pdf": 702,
	"./aj-Institution Data Submitted for NIRF 2025 - Engineering Category.pdf": 79826,
	"./ak-Institution Data Submitted for NIRF 2025 - Innovation Category.pdf": 86463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;